<script>
import entreprise from '../../../assets/icons/ic-entreprise.svg'
import ic_enterprise from "@/assets/icons/ic_society-small.svg";
import { updateServiceRequest } from "@/component/cdevs/allFunctions";
import ic_service from "@icon/ic_service.svg";

export default {
  name: 'AffectationPopup',
  data() {
    return {
      icons: { entreprise, ic_enterprise, ic_service },
      name: '',
      description: null,
      email: ''
    };
  },
  emits: ['closeDetail'],
  props: {
    oneDetail: {
      type: Object,
      required: true,
    },
  },

  methods: {
    closeDetail() {
      this.$emit('closeDetail');
    },

    // Function to create new accountant
    async markAsTreated() {
        this.charge = true;
        const data = {
          apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
          id: this.oneDetail.request.id,
          state: 'TREATED',
        }
        await updateServiceRequest(data).then(response => {
          console.log(response)
          this.charge = false;
          this.$toast.success('Demande traitée avec succès');
          this.$emit('closeDetail', true)
        }).catch(error => {
          console.log(error)
          this.charge = false;
          this.$toast.error('Une erreur est survenue');
        })
      },
  },
}
</script>

<template>
  <div
    class="popup-overlay"
  >
    <div class="popup-content bg-white w-1/3 py-5 relative">
      <div class="flex font-c7 text-c22 colorBorderB pb-5 px-5">
        Description du besoin 
      </div>
      <div class="mt-5">
        <div class="bgTitle flex items-center gap-3 p-4 rounded-10 mx-5">
          <icon
            :data="icons.ic_service"
            height="20"
            width="20"
            class="w-5 h-5"
            original
          />
          <div class="font-c7 text-c20 textTitle">
            {{ oneDetail?.request?.serviceChoice.title || '--' }}
          </div>
        </div>
        <div class="bgDesc gap-3 p-4 rounded-10 mt-5 mx-5">
          <div class="flex justify-start font-c4 text-c20 textTitle">
            {{ oneDetail?.request?.serviceChoice?.description || '--' }}
          </div>
        </div>

        <div class="flex justify-end items-center mt-5 mx-5">
          <div
            class="font-c5 text-red-500 mt-2 text-sm ml-5 cursor-pointer annulerr px-7 py-3 rounded-8"
            @click="closeDetail"
          >
            Fermer
          </div>
          <div
            v-if="oneDetail.request.state !== 'TREATED'"
            class="text-red-500 mt-2 text-sm ml-5 cursor-pointer save px-10 py-3 rounded-8 text-white"
            @click="markAsTreated()"
          >
            Marquer comme traité
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.textTitle{
  color: #303030;
}
.bgTitle{
  background-color: #F7DCBC70;
}
.bgDesc{
  background-color: #FAFBFD;
}
.annulerr{
  background-color: #EFF4FB;
}
.save{
  background-color: #241A72;
}
.colorBorderB{
  border-bottom: 3px solid #E7EEF8;
}
.bgInpout{
  /* background-color: #F0F2F7; */
  border: 1px solid #F0F2F7
}
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.popup-content {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 20rem;
  
}
.relative {
  position: relative;
}
</style>
